module.exports = __webpack_public_path__ + "img/IT0000515290068.9c6cf1b4.png";